<template>
  <div class="calendar-view">

    <filters
      v-if="config.user_filters"
      :params="params"
      @set-filter="setFilter">
    </filters>
    <hr>
    <div v-if="events">

      <div class="card-view" :class="{ loading: status.busy }">
        <div class="grid-x grid-padding-x" :class="gridClasses">
          <div 
            v-for="event in events" 
            :key="event.id"
            class="cell">
            <event-card :event="event"></event-card>
          </div>
        </div>
      </div>

      <pagination 
        v-if="totalPages > 1"
        :total="totalPages"
        :curr-page="params.paging.page"
        @to-page="setPage">
      </pagination>

    </div>
    <div v-else-if="result">
      <p>We cannot find events for the current criteria.</p>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import EventCard from '@/EventCard.vue'
import Filters from '@/Filters.vue'
import Pagination from '@/Pagination.vue'
const VueScrollTo = require('vue-scrollto')

export default {
  name: 'CalendarView',
  components: {
    EventCard, Filters, Pagination
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      status: {
        init: true,
        busy: false,
        error: false
      },
      grid: {
        small: 1,
        medium: 3,
        large: 3
      },
      params: {
        filters: {
          category: [],
          site: [],
          date_range: {
            startDate: null,
            endDate: null
          },
          query: ''
        },
        paging: {
          page: 1,
          ipp: 15
        }
      },
      result: false
    }
  },
  methods: {
    init () {

      // Set the initial date range
      const start = dayjs()
      const end = start.add(1, 'M')
      this.params.filters.date_range = {
        startDate: start.format('YYYY-MM-DD'),
        endDate: end.format('YYYY-MM-DD')
      }

      // Check for url params
      for (const filter of ['category', 'site']) {
        console.log('check if', filter, 'in query')
        if (filter in this.$route.query) {
          try {
            console.log('parse')
            let values = JSON.parse(this.$route.query[filter])
            console.log('values', values)
            this.params.filters[filter] = values
          } catch (e) {
            console.log(e)
          }
        }
      }

      this.getEvents()
    },
    setFilter (filter) {
      this.params.filters[filter.name] = filter.data
      this.getEvents()
    },
    setPage (page) {
      this.params.paging.page = page
      this.getEvents()
    },
    setURL () {
      console.log('setting url')
      const url_params = ['category', 'site']
      let q = {}
      for (const param of url_params) {
        let value = this.params.filters[param]
        if (value && value.length != 0) {
          q[param] = JSON.stringify(value)
        }
      }

      this.$router.replace({ path: '/calendar', query: q }).catch(()=>{})
    },
    getEvents (reset) {
      this.status.busy = true

      const do_scroll = (this.result != false)

      if (reset) {
        this.params.paging.page = 1
      }
      axios.post(this.config.url + '/events', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: this.params,
        responseType: 'json'
      })
      .then(function (response) {
        if (response.data.success) {
          this.result = response.data.result
          if (this.status.init == false) {
            this.setURL()
          } else {
            this.status.init = false
          }
          if (do_scroll) {
            const elem = this.$root.$el
            this.$nextTick(() => {
              VueScrollTo.scrollTo(elem, 100, { offset: -20 })
            })
          }
        } else {
          this.status.error = response.data.message
        }
      }.bind(this))
      .catch(function (error) {
        this.status.error = error
      }.bind(this))
      .finally(function () {
        this.status.busy = false
      }.bind(this))
    }
  },
  computed: {
    config () {
      return this.$root.$options.config
    },
    events () {
      if (this.result && this.result.items.length) {
        return this.result.items
      }
      return false
    },
    gridClasses () {
      const sizes = this.grid
      return [
        'small-up-' + sizes.small,
        'medium-up-' + sizes.medium,
        'large-up-' + sizes.large
      ]
    },
    totalPages () {
      if (this.result) {
        const num_items = this.result.total
        return Math.ceil(num_items / this.params.paging.ipp)
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
